import Stack from "@mui/material/Stack";
import CasinoOutlinedIcon from "@mui/icons-material/CasinoOutlined";
import {Checkbox, FormControlLabel} from "@mui/material";
import React, {useState} from "react";
import {styled} from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import {useSignals} from "@preact/signals-react/runtime";
import {s_char} from "../../_signals/s_char";
import {rollerSetRoll} from "../../_helper/rollBehave";
import {s_char_attr_wil_step, s_char_attr_zae_step} from "../../_signals/s_char_attr";
import {IRollerRoll} from "../../_interfaces/IRoller";
import {s_app_mobile, s_app_mobile_tab} from "../../_signals/s_app";

const Item = styled(Paper)(({theme}) => ({
    backgroundColor: '#fff', ...theme.typography.body2, padding: 4, height: '100%', textAlign: 'center', color: '#000',
}));

function CharErholungsproben() {

    useSignals();

    const [EPStrain, setEPStrain] = useState(false);
    const [EPNoStep, setEPNoStep] = useState(false); // ohne stufe z.b. tränke/zauber

    const erholungsprobe = () => {
        let step = 0;
        const ep = s_char.value.ep;
        const ep_used = s_char.value.ep_used;

        if (!EPNoStep && ep - ep_used > 0) {
            step = s_char_attr_zae_step.value;
            if (EPStrain) {
                step = step + s_char_attr_wil_step.value;
            }
        }

        const roll: IRollerRoll = {
            title: 'Erholungsprobe',
            attribute: '',
            step: step,
            step_mod: 0,
            karma: false,
            as: 'ep',
            as_fix: true,
            strain: 0,
            target: [],
            targetVS:'',
            vs: 0,
            canusekarma: s_char.value.ep_karma,
        };
        rollerSetRoll(roll, true);
    }

    return <Item>
        <div>Erholungsproben: {s_char.value.ep} - {s_char.value.ep_used}</div>
        {s_char.value.schaden > 0 ?
            (s_app_mobile.value && s_app_mobile_tab.value == 'roll') || !s_app_mobile ?
                <>
                    <Stack direction={s_app_mobile.value ? 'column' : 'row'} alignItems="center">
                        <CasinoOutlinedIcon onClick={() => erholungsprobe()}/>

                        <FormControlLabel
                            style={s_app_mobile.value ? {marginTop: 8, marginLeft: 4} : {marginLeft: 4}}
                            control={
                                <Checkbox
                                    defaultChecked={EPStrain}
                                    onChange={(e) => setEPStrain(e.target.checked)}
                                    inputProps={{'aria-label': 'controlled'}}
                                />
                            }
                            label={'mit Betäubung'}
                        />

                        <FormControlLabel
                            style={s_app_mobile.value ? {marginTop: 8, marginLeft: 4} : {marginLeft: 4}}
                            control={
                                <Checkbox defaultChecked={EPNoStep}
                                          onChange={(e) => setEPNoStep(e.target.checked)}
                                />
                            }
                            label="ohne eigene Erholungsprobe"
                        />
                    </Stack>
                </>:null

        :null}
    </Item>

}

export default CharErholungsproben
